import { configureStore } from "@reduxjs/toolkit";
import actionItems from "./feature/action-item/actionItemsSlice";
import adverseEventReducer from "./feature/adverseEventSlice";
import assessmentReducer from "./feature/assesmentSlice";
import authReducer from "./feature/auth/authSlice";
import bookingReducer from "./feature/bookingSlice";
import dashboardReducer from "./feature/dashboardSlice";
import caseReducer from "./feature/case-list.slice";
import caseListCard from "./feature/case-list/caseListSlice";
import caseTabReducer from "./feature/case-tab/caseSlice";
import caseDetails from "./feature/case/caseSlice";
import ciomsData from "./feature/case/ciomsDataSlice";
import filterReducer from "./feature/filters/filterSlice";
import keyValueReducer from "./feature/keyValueSlice";
import layoutConfig from "./feature/layoutConfigSlice";
import loadingReducer from "./feature/loadingSlice";
import patientForm from "./feature/patient/patientFormSlice";
import pdfToggle from "./feature/pdf/pdfSlice";
import selectedField from "./feature/pdf/selectedFieldSlice";
import readonlyReducer from "./feature/readonly/readonlySlice";
import reporterFormReducer from "./feature/reporter/reporterFormSlice";
import sidebarReducer from "./feature/sidebarSlice";
import snackbarReducer from "./feature/snackbarSlice";
import testProcedureReducer from "./feature/test-procedure/testProcedureSlice";
import userReducer from "./feature/userSlice";
import workflowReducer from "./feature/workflow/workflowSlice";
import productsReducer from "./feature/productsSlice";
import chatLoadingReducer from "./feature/chat/chatLoadingSlice";
import dbChatReducer from "./feature/dbChat/dbChatSlice";
import activityReducer from "./feature/activity/activitySlice";
export const rootReducer = {
  sidebar: sidebarReducer,
  keyValue: keyValueReducer,
  layoutConfig: layoutConfig,
  bookings: bookingReducer,
  user: userReducer,
  assessment: assessmentReducer,
  reporterFrom: reporterFormReducer,
  pdfToggle: pdfToggle,
  patientForm: patientForm,
  selectedField: selectedField,
  case: caseDetails,
  ciomsData: ciomsData,
  loading: loadingReducer,
  cases: caseReducer,
  workflow: workflowReducer,
  snackbar: snackbarReducer,
  adverseEvent: adverseEventReducer,
  caseListCard: caseListCard,
  auth: authReducer,
  dashboard: dashboardReducer,
  testProcedures: testProcedureReducer,
  actionItems: actionItems,
  filters: filterReducer,
  caseTab: caseTabReducer,
  readonly: readonlyReducer,
  products: productsReducer,
  chatLoading: chatLoadingReducer,
  dbChat: dbChatReducer,
  activity: activityReducer,
};

import { injectStore } from "@/lib/axios";
import SessionManager from "@/lib/sessionManager";
import { injectStoreForTokenRefresh } from "@/lib/tokenRefresh";

export const store = configureStore({
  reducer: rootReducer,
});

// Inject store into axios and SessionManager to break circular dependencies
injectStore(store);
SessionManager.getInstance().setStore(store);
injectStoreForTokenRefresh(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
